import BrandsState from '../types/BrandsState';

export const state: BrandsState = {
  brands: []
}
